/* eslint-disable @next/next/no-img-element */
import { Main } from "app/core/components/layout/Main"
import Footer from "app/splash/components/Footer"
import Header from "app/splash/components/Header"
import Head from "next/head"

import TemplatesLayout from "app/core/layouts/Template"
// import { Templates } from "app/splash/components/splash-sections/Templates"
import { Paragraph, LargeHeading } from "app/splash/components/misc"
import { SignUpButton } from "app/splash/components/Main"
import { Reviews } from "app/splash/components/splash-sections/Reviews"
import { useSession } from "@blitzjs/auth"
import TemplateSortSelect from "app/paywalls/components/tables/TemplateSortSelect"
import { useState } from "react"
import TemplateGallery, { TTemplateSortBy } from "app/paywalls/components/TemplateGallery"
import { useQuery } from "@blitzjs/rpc"
import getPaywallTemplatesPublicCount from "app/paywalls/queries/getPaywallTemplatesPublicCount"

const Templates = () => {
  const session = useSession({ suspense: false })
  const [templateSortBy, setTemplateSortBy] = useState<TTemplateSortBy>("createdAtDesc")
  const [templateCount] = useQuery(
    getPaywallTemplatesPublicCount,
    {},
    {
      suspense: false,
    }
  )

  return (
    <>
      <Header />

      <Main>
        <Head>
          <title>Templates — Superwall</title>
        </Head>
        <div className="h-24"></div>

        {/* Heading & Description */}
        <div className="flex flex-col gap-6 md:gap-14">
          <div className="flex flex-col gap-1 text-center items-center pb-10 ">
            <LargeHeading>{`One-click templates to get you started`}</LargeHeading>
            <Paragraph className="!max-w-[750px] !text-opacity-60">{`Choose a template to customize for your app and get started in minutes.`}</Paragraph>
          </div>

          {/* Seperator */}
          <div className="relative -mt-3">
            <p className="absolute sm:block hidden left-[50%] transform translate-x-[-50%] translate-y-[-50%] uppercase text-sm tracking-widest text-white/30 bg-grayscale-darkest p-1 px-2 rounded-xl z-50">
              {templateCount?.count} Templates
            </p>
            {/* Sort by */}
            <div className="flex items-center justify-center w-full absolute translate-y-[-50%] z-50">
              <div className="w-full flex justify-start sm:justify-end max-w-7xl">
                <div className="bg-grayscale-darkest z-10 p-2 rounded-lg -mr-2">
                  <TemplateSortSelect
                    templateSortBy={templateSortBy}
                    setTemplateSortBy={setTemplateSortBy}
                  />
                </div>
              </div>
            </div>
            <div className="inline-flex items-center justify-center w-full absolute translate-y-[-50%]">
              <div
                className={`h-[1px] w-[100%] max-w-7xl bg-gradient-to-r from-sky-300/0 via-purple-200/20 to-sky-300/0`}
              />
            </div>
          </div>

          {/* Template Gallery */}
          <TemplateGallery isPublic={true} templateSortBy={templateSortBy} v4Only={true} />
        </div>

        {!session.userId && (
          <div className="mt-20 md:-mb-28 px-1">
            <Reviews title="So, what are you waiting for?">
              <div className="flex flex-row items-center gap-10 mb-16">
                <SignUpButton
                  source="main-cta"
                  mainCta="Start for free"
                  bookDemoCta={"Talk to sales"}
                  showBookDemo={true}
                ></SignUpButton>
              </div>
            </Reviews>
          </div>
        )}
      </Main>
      <Footer />
    </>
  )
}

Templates.getLayout = (page) => <TemplatesLayout>{page}</TemplatesLayout>

export default Templates
